import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = '';

function ManufacturerSearchComponent({ onSelectVehicle }) {
  const [manufacturers, setManufacturers] = useState([]);
  const [selected, setSelected] = useState('ford');
  const [vehicles, setVehicles] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadManufacturers();
  }, []);

  const loadManufacturers = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/manufacturers`);
      const mfrs = Array.isArray(res.data) ? res.data : res.data.manufacturers || [];
      setManufacturers(mfrs);
      if (mfrs.length > 0) {
        await loadVehicles(mfrs[0]);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error loading manufacturers:', error);
      setManufacturers([]);
      setLoading(false);
    }
  };

  const loadVehicles = async (mfr) => {
    try {
      const res = await axios.get(`${API_BASE}/api/manufacturer/${mfr}`);
      setSelected(mfr);
      setVehicles(res.data.vehicles || []);
      setStats(res.data);
    } catch (error) {
      console.error(`Error loading vehicles for ${mfr}:`, error);
      setVehicles([]);
      setStats(null);
    }
  };

  const parseVehicleStr = (vehicleStr) => {
    if (!vehicleStr) return { year: 'Unknown', make: 'Unknown', model: 'Unknown' };
    
    const parts = vehicleStr.split(' ');
    const year = parts[0] || 'Unknown';
    const make = parts[1] || 'Unknown';
    const model = parts.slice(2).join(' ') || '';
    
    const formatText = (str) => str.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');

    return {
      year,
      make: formatText(make),
      model: formatText(model)
    };
  };

  const dataMap = {
    ford: 5118, jeep: 1773, honda: 1736, hyundai: 1113,
    chevrolet: 266, toyota: 266, nissan: 220, acura: 15
  };

  if (loading) return <div style={{padding: '20px'}}>Loading...</div>;

  return (
    <div className="manufacturer-search-section">
      <h2>🏭 Browse by Manufacturer</h2>
      <p className="search-desc">Select a manufacturer to see all vehicles and click one to analyze</p>

      <div className="mfr-selector-wrapper">
        <label>Select Manufacturer:</label>
        <select 
          value={selected} 
          onChange={(e) => loadVehicles(e.target.value)}
          className="mfr-dropdown-large"
        >
          {manufacturers.map(m => (
            <option key={m} value={m}>
              {m.charAt(0).toUpperCase() + m.slice(1)} ({dataMap[m.toLowerCase()] || 0} complaints)
            </option>
          ))}
        </select>
      </div>

      <div className="mfr-bar-chart">
        <h3>Manufacturer Comparison</h3>
        <div className="bars-container">
          {manufacturers.map((mfr, idx) => {
            const complaints = dataMap[mfr.toLowerCase()] || 0;
            const width = (complaints / 5118) * 100;
            const colors = ['#003f87', '#00a8cc', '#00d4ff', '#76c893', '#ffd166', '#ef476f', '#a23b72', '#f18f01'];
            const isSelected = selected === mfr;
            
            return (
              <div key={mfr} className={`mfr-bar-item ${isSelected ? 'active' : ''}`} onClick={() => loadVehicles(mfr)}>
                <div className="mfr-bar-label">{mfr.charAt(0).toUpperCase() + mfr.slice(1)}</div>
                <div className="mfr-bar-bg">
                  <div 
                    className="mfr-bar-fill" 
                    style={{width: `${width}%`, backgroundColor: colors[idx]}}
                  >
                    <span className="mfr-bar-text">{complaints}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {stats && (
        <div className="mfr-fleet-info">
          <h3>{selected.charAt(0).toUpperCase() + selected.slice(1)} Fleet Overview</h3>
          <div className="fleet-stats-grid">
            <div className="fleet-stat">
              <div className="stat-label">Total Vehicles</div>
              <div className="stat-value">{stats.total_vehicles}</div>
            </div>
            <div className="fleet-stat">
              <div className="stat-label">Total Complaints</div>
              <div className="stat-value">{stats.total_complaints}</div>
            </div>
            <div className="fleet-stat">
              <div className="stat-label">Avg Reliability</div>
              <div className="stat-value">{stats.average_reliability}%</div>
            </div>
            <div className="fleet-stat">
              <div className="stat-label">Avg MTTF</div>
              <div className="stat-value">{stats.average_mttf} yr</div>
            </div>
          </div>
        </div>
      )}

      <h4 style={{marginTop: '30px', marginBottom: '15px'}}>Click a vehicle to view details:</h4>
      <div className="mfr-vehicle-list">
        {vehicles.length > 0 ? vehicles.slice(0, 20).map((vehicle) => {
          const { year, make, model } = parseVehicleStr(vehicle.vehicle_str);
          
          return (
            <div 
              key={vehicle.vin} 
              className="mfr-vehicle-card"
              onClick={() => onSelectVehicle(vehicle)}
              style={{cursor: 'pointer'}}
            >
              <div style={{padding: '12px'}}>
                <div style={{fontWeight: 'bold', fontSize: '14px', marginBottom: '5px'}}>
                  {vehicle.vin}
                </div>
                <div style={{color: '#666', fontSize: '13px', marginBottom: '8px'}}>
                  {year} {make} {model}
                </div>
                <div style={{display: 'flex', gap: '15px', fontSize: '12px', color: '#999'}}>
                  <span>{vehicle.complaint_count} complaints</span>
                  <span>{vehicle.reliability_score}% reliability</span>
                </div>
              </div>
            </div>
          );
        }) : <p style={{padding: '20px', color: '#666'}}>No vehicles found</p>}
      </div>
    </div>
  );
}

export default ManufacturerSearchComponent;
